export default __webpack_public_path__ + "static/media/Telematics_Icon.68eddc2e.svg";